<template>
  <div class="signin-bg">
    <Header></Header>
    <search-header></search-header>
    <div class="panel">
      <div class="panel-cont dw-1200 pr" id="panel-cont">
        <!-- 左栏 -->
        <sidebar></sidebar>
        <!--右边内容-->
        <div class="about_right" id="about_right">
          <router-view />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from './dashboard/components/Sidebar';
import SearchHeader from './SearchHeader'
export default {
  name: "Dashboard",
  components: {
    Header,
    Footer,
    SearchHeader,
    Sidebar
  },
  data() {
    return {
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo(){
      if(this.getCookie('user_type') == 2){
        this.$router.go(-1);
      }else {
        this.$get('/me').then(res => {
          if (res.data.user.is_admin == 0 && res.data.user.type == 2) {
            this.setCookie('user_type',2)
            this.$router.go(-1);
          }
        })
      }
    }
  }
}
</script>
<style>

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: #333;
}
div,
b,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
li,
dl,
dd,
header,
footer {
  margin: 0;
  padding: 0;
  list-style: none;
}
em,
i,
b,
strong {
  font-style: normal;
  font-weight: normal;
}
.ct {
  text-align: center;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.pr {
  position: relative;
}
.pa {
  position: absolute;
}
.hd {
  overflow: hidden;
}
.flard {
  display: flex;
  justify-content: space-around;
}
.flbt {
  display: flex;
  justify-content: space-between;
}
.w-1024 {
  width: 1024px;
  margin: 0 auto;
}
.w-1190 {
  width: 1190px;
  margin: 0 auto;
}
.dw-1200 {
  width: 1190px;
  margin: 0 auto;
  overflow: hidden;
}
/*ͷ������*/
img {
  vertical-align: top;
}

.nav li {
  margin: 0 20px;
  text-align: center;
}
.nav li.active::after {
  content: "";
  display: block;
  background: #ff9f00;
  height: 2px;
  width: 80%;
  margin: -15px auto 0;
}
.nav li.active {
  font-weight: 600;
}
.loging .kefu img,
.loging .tishi img {
  margin: 17px 20px 0;
}
.tishi {
  position: relative;
}
.tishi span.num {
  position: absolute;
  background: #e74c3a;
  border-radius: 10px;
  color: #fff;
  min-width: 20px;
  height: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  top: 15px;
  right: 15px;
  padding: 0 4px;
}
.loging .user-down img {
  margin: 30px 10px 0;
}
.user-down {
  cursor: pointer;
  position: relative;
}
.jiantou {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
/*����*/
.serch {
  background: #f7f7f7;
  display: flex;
  justify-content: space-between;
  height: 50px;
  border-bottom: 2px solid #1f1f1f;
}
.xiala {
  font-size: 16px;
}
.dropdown {
  width: 140px;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
}
.inpt {
  width: 950px;
  padding-right: 10px;
  position: relative;
}
input {
  border: none;
  height: 48px;
  line-height: 48px;
  width: 100%;
  padding-left: 40px;
  outline: none;
  font-size: 16px;
  background: #f7f7f7;
}
input::-webkit-input-placeholder {
  color: #999999;
  font-size: 16px;
}
input:-moz-placeholder {
  color: #999999;
  font-size: 16px;
}
input::-moz-placeholder {
  color: #999999;
  font-size: 16px;
}
input:-ms-input-placeholder {
  color: #999999;
  font-size: 16px;
}
.icon-scrch {
  width: 110px;
  text-align: center;
  cursor: pointer;
}
.icon-scrch img {
  margin-top: 13px;
  cursor: pointer;
}
/*������*/
.xiala img {
  margin-top: 17px;
}
.inpt img {
  margin-top: 12px;
  position: absolute;
}
.dropdown {
  position: relative;
}
.dropdown_menu {
  background: #f7f7f7;
  position: absolute;
  top: 48px;
  right: 30px;
  z-index: 1000;
  display: none;
  width: 110px;
  padding: 10px 0;
  text-align: center;
  border-top: 1px solid #ddd;
}
.dropdown_menu dd {
  line-height: 34px !important;
}
.dropdown dl dd a {
  color: #333;
  line-height: 34px;
  font-size: 14px;
}
.top-arrow1,
.top-arrow2 {
  width: 0;
  height: 0;
  display: block;
  position: absolute;
  left: 30px;
  top: -17px;
  z-index: 5; /*����ie8-*/
  border-top: 8px transparent dashed;
  border-left: 6px transparent dashed;
  border-right: 6px transparent dashed;
  border-bottom: 8px white solid;
  overflow: hidden;
}
.top-arrow1 {
  border-bottom: 9px #ddd solid;
}
.top-arrow2 {
  top: -15px;
  border-bottom: 9px #f7f7f7 solid;
}
/*�ײ�*/
footer {
  height: 180px;
  background: #fff;
  padding: 70px 0 0;
}
footer p {
  font-size: 12px;
  color: #999;
  text-align: center;
}
/*����*/
.overCurtain {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  opacity: 0.7;
  display: none;
  background: #0e0e0e;
  z-index: 11;
}
/*֪ͨ��Ϣ*/
.tongzhi {
  height: 480px;
  width: 380px;
}
.kefu-list {
  height: 540px;
  width: 380px;
}
.tongzhi,
.kefu-list {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  display: none;
  z-index: 1111;
  background: #fff;
  padding: 25px 30px;
  font-size: 14px;
  z-index: 1111111111111;
}
.tongzhi p.hd,
.kefu-list p.hd {
  margin-bottom: 10px;
}
.tongzhi p.hd img.fr,
.kefu-list p.hd img.fr {
  cursor: pointer;
}
.tongzhi p.hd span,
.kefu-list p.hd span {
  font-size: 18px;
  font-weight: 600;
}
.tongzhi-list ul li {
  border-bottom: 1px solid #ccc;
  margin-top: 20px;
}
.tongzhi-list ul li p {
  font-size: 12px;
  color: #999;
}
.tongzhi-list ul li span {
  font-size: 12px;
  display: inline-block;
  margin: 10px 0 15px;
}
.tongzhi-list ul {
  overflow-x: auto;
  height: 390px;
}
.tongzhi-list ul::-webkit-scrollbar {
  display: none;
}
/*�ͷ�����*/
.kefu-cont {
  margin-top: 30px;
}
.kefu-img {
  margin-bottom: 30px;
}
.kefu-img img {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin-right: 30px;
}
.kefu-name {
  margin: 12px 0 10px;
  font-size: 16px;
  font-weight: 600;
}
.kefu-tal {
  font-weight: 600;
}
.ywq li img {
  margin-right: 10px;
}
.ywq li {
  margin: 15px 0;
}
.erweima p {
  width: 120px;
  height: 120px;
  padding: 5px;
  margin: 20px auto 10px;
}
.erweima span {
  font-size: 12px;
  color: #999;
}
.mingpian a {
  display: inline-block;
  background: #f7f7f7;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-size: 14px;
  color: #666;
  border-radius: 20px;
  text-align: center;
  margin-top: 25px;
}
.panel {
  background: #f7f7f7;
  padding: 46px 0 114px;
  text-align: left;
}
.panel-cont {
}
.about_left {
  padding: 25px 35px 30px;
  left: -173px;
  width: 160px;
  float: left;
}
.about_right .title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}
.about_left,
.midel-top-left,
.midel-top-right,
.shang,
.user-data,
.yhzu {
  background-color: #fff;
}
.shang,
.user-data {
  margin-bottom: 13px;
  padding: 25px 35px 30px;
}
.about_right > div.show {
  display: block;
}
.about_right > div {
  display: none;
}
.xxhz {
}
.gs-name {
}
.about_right {
  min-height: 320px;
  float: right;
  width: 1020px;
}
.dzmc {
  line-height: 30px;
  font-size: 14px;
}
.dzmc a {
  color: #3377aa;
}
.lx {
  line-height: 30px;
  font-size: 14px;
  margin-right: 50px;
}
.lx p {
  margin-left: 33px;
}
.lx span {
  color: #999;
}
.midel-top-left,
.midel-top-right,
.yhzu {
  padding: 30px 35px 20px;
  font-size: 14px;
}
.midel-top-left {
  margin-right: 13px;
  width: 727px;
}
.syed {
  line-height: 40px;
}
.mt13 {
  margin-top: 13px;
}
.midel-top-right {
  width: 460px;
}
.circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 10px 0 0;
  position: relative;
  background: #f7f7f7;
}
.pie_left,
.pie_right {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
}
.left,
.right {
  display: block;
  width: 60px;
  height: 60px;
  background: #fe9f00;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}
.pie_right,
.right {
  clip: rect(0, 30px, auto, 0);
}
.pie_left,
.left {
  /* clip: rect(0, auto, auto, 60px); */
}
.mask {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  left: 5px;
  top: 5px;
  background: #fff;
  position: absolute;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  font-weight: 600;
}
.xyt-ed {
  height: 40px;
  margin-top: 10px;
}
.riqi div.fl {
  height: 28px;
  line-height: 28px;
}
.riqi div.start {
  color: #3377aa;
  background: #f1f9ff;
  border: 1px solid#3377AA;
  border-radius: 5px;
  padding: 0 8px;
  margin-right: 10px;
}
.riqi div.end {
  background: #f7f7f7;
  color: #999;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 8px;
}

.xinxi {
  padding: 20px 0 15px;
}
.xinxi span {
  display: block;
  color: #999999;
  height: 24px;
  line-height: 24px;
}
.tab-title,
.tab-title-yhgl,
.tab-title-glqy {
  margin: 20px 0;
  font-weight: 500;
  color: #999;
}
.tab-title li,
.tab-title-yhgl li,
.tab-title-glqy li {
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.tab-title li p i,
.tab-title-glqy li p i {
  display: none;
  width: 80%;
  height: 3px;
  background: #ff9f00;
  margin: 3px auto;
}
.blk {
  display: block !important;
}
.none {
  display: none !important;
}
.img-tab {
  height: auto;
}
.list-cont,
.list-cont-yhgl,
.list-cont-glqy {
  display: none;
}
.tab-title li.act p,
.tab-title-yhgl li.act p,
.tab-title-glqy li.act p {
  font-weight: 600;
  color: #333;
}
.list-cont p,
.list-cont-yhgl p,
.list-cont-glqy p {
  line-height: 30px;
}
.rdo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: #f7f7f7;
  text-align: center;
  padding-top: 20px;
  margin: 0 auto;
}
.rdo span.num {
  font-size: 36px;
  font-weight: 600;
}
.riqi {
  margin-top: 20px;
  white-space: nowrap;
  overflow: auto;
}
.yuangong {
  width: 50%;
}
.yg-name {
  margin-top: 15px;
  text-align: center;
}
.yg-name a {
  display: inline-block;
  width: 46px;
  float: left;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.clxq a {
  display: inline-block;
  width: 96px;
  height: 30px;
  line-height: 30px;
  color: #3377aa;
  border: 1px solid #3377aa;
  border-radius: 15px;
  text-align: center;
  margin: 10px auto 0;
}
.sqzt li {
  overflow: hidden;
  margin-bottom: 15px;
}
.sqzt li img {
  margin-right: 15px;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  margin-top: 8px;
}
.sqzt li div.fl span {
  color: #999;
  display: inline-block;
  line-height: 28px;
}
.sqzt li div.fl {
  width: 400px;
}
.sqzt li div.fl p {
  line-height: 22px;
}
.bumen li {
  overflow: hidden;
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
}
.bumen li span {
  float: left;
  margin-right: 25px;
  color: #999;
}
.bumen li:nth-child(2n) {
  background: #f7f7f7;
}
.bumen li a {
  float: left;
}
/*����*/
/*.overCurtain{position:fixed;height:100%;width:100%;left:0px;top:0px;opacity:0.7;display:none;background:#0E0E0E;}*/
.huizong {
  height: 490px;
  width: 460px;
}
.zhuangtaiqu,
.shanchu,
.huishou-edu,
.guanlianqiye {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  z-index: 1111111111111;
  background: #fff;
  padding: 25px 30px;
  border-radius: 10px;
  font-size: 14px;
}
.zhuangtaiqu p.hd img.fr {
  cursor: pointer;
}
input.tianxiesq {
  border: none;
  height: 40px;
  line-height: 40px;
  width: 280px;
  padding: 0 10px 0 0;
  outline: none;
  font-size: 14px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input:-moz-placeholder {
  color: #999999;
}
input::-moz-placeholder {
  color: #999999;
}
input:-ms-input-placeholder {
  color: #999999;
}
.huizong h2 {
  font-size: 20px;
  margin: 15px 0 30px;
}
.ul-ipt li {
  height: 40px;
  line-height: 40px;
  background: #f7f7f7;
  border-radius: 20px;
  width: 380px;
  padding-left: 15px;
  overflow: hidden;
  margin-bottom: 20px;
}
.queding a {
  display: inline-block;
  padding: 0 40px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  background: #ff9f00;
  border-radius: 30px;
  margin-top: 25px;
}
/*��Ȩ��Ϣ*/
input.sq-data {
  width: 400px;
  border: none;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  outline: none;
  font-size: 14px;
  border-radius: 20px;
}
.icon-scrchmb {
  display: inline-block;
  background: #ff9f00;
  border-radius: 20px;
  width: 80px;
  margin-left: 10px;
  height: 40px;
  text-align: center;
  cursor: pointer;
}
.icon-scrchmb img {
  margin-top: 9px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.sq-new p {
  height: 36px;
  line-height: 36px;
  border: 1px solid #3377aa;
  border-radius: 18px;
  background: #f1f9ff;
  color: #3377aa;
  padding: 0 15px;
  cursor: pointer;
  display: inline-block;
  margin: 40px 0 20px;
  font-size: 14px;
}
.ul-hd li {
  float: left;
  margin-right: 15px;
  background: #f7f7f7;
  padding: 30px;
  height: 200px;
  width: 271px;
}
.ul-hd li p {
  font-weight: 600;
  margin-bottom: 10px;
}
.ul-hd li span {
  color: #999;
  font-size: 14px;
  display: block;
  line-height: 26px;
}
.ul-hd li:nth-child(4n) {
  margin-right: 0px;
}
.scbj a {
  display: inline-block;
  margin-right: 15px;
  height: 22px;
  line-height: 22px;
  padding: 0 10px;
  color: #3377aa;
  border: 1px solid #3377aa;
  font-size: 14px;
  border-radius: 12px;
}
.scbj {
  margin-top: 10px;
}
.page .dqye {
  width: 50px;
  border-bottom: 1px solid #000000;
  text-align: center;
  font-weight: 600;
}
.zuo img,
.you img {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.you img {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
.allpage {
  margin: 0 10px;
}
.souquan {
  height: 300px;
  width: 450px;
  z-index: 111111111111;
}
.zhuan-ul li {
  height: 50px;
  line-height: 50px;
  background: #f7f7f7;
  border-radius: 30px;
  width: 385px;
  padding-left: 25px;
  overflow: hidden;
  margin: 25px 0 10px;
}
.souquan h2,
.yhguanli h2 {
  font-size: 18px;
  margin: 30px 0 10px 25px;
}
.cjxg {
  text-align: center;
  display: none;
}
.cjxg img {
  display: block;
  width: 60px;
  height: 60px;
  margin: 50px auto;
}
.cjxg span {
  font-size: 18px;
}
.shanchu {
  width: 350px;
  height: 220px;
}
.shanchu p,
.huishou-edu p.font {
  font-size: 16px;
  margin: 40px auto 30px;
}
.shanchu a,
.huishou-edu a {
  font-size: 14px;
  background: #ff9f00;
  display: inline-block;
  color: #fff;
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
  border-radius: 20px;
  margin: 20px 10px;
}
.shanchu a.qued {
  background: #cccccc;
}
/*.�û�����*/
.user-serch {
  height: 40px;
  line-height: 40px;
  background: #f7f7f7;
  border-radius: 20px;
  width: 485px;
  padding-left: 20px;
  overflow: hidden;
}
.user-serch span img {
  margin-top: 14px;
  width: 12px;
  height: 12px;
}
.user-serch input {
  border: none;
  height: 40px;
  line-height: 40px;
  padding: 0 20px 0 10px;
  outline: none;
  font-size: 14px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  width: 390px;
}
.flst {
  display: flex;
  justify-content: flex-start;
}
.end {
  background: #f7f7f7;
  padding: 0 20px;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  margin: 0 10px;
}
.end img {
  margin: 10px 5px 0 0;
}
.xian {
  height: 1px;
  width: 10px;
  background: #c6c6c6;
  margin-top: 19px;
}
.flbt .user-guanli-style {
  margin: 0;
  width: 740px;
}
.yhyg {
  background: #f7f7f7;
  padding: 45px 30px;
  width: 50%;
  margin: 70px 5px 0;
}
.yhyg b {
  font-size: 26px;
  font-weight: 600;
}
.yhyg div.fl {
  margin-left: 10px;
}
.bianji {
  cursor: pointer;
}
.news-jia {
  height: 36px;
  line-height: 36px;
  border-radius: 18px;
  padding: 0 15px;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  margin-right: 10px;
}
.xinjiayonghu {
  border: 1px solid #ff9f00;
  background: #fff5e5;
  color: #ff9f00;
}
.xinjiayonghuzu {
  border: 1px solid #5ebc7f;
  background: #eff8f2;
  color: #5ebc7f;
}
.mt20 {
  margin-top: 20px;
}
.tab-title {
  background: #f7f7f7;
  border-bottom: 2px solid #333;
  padding: 0 10px;
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: flex-start;
}
.tab-title span {
  font-weight: 600;
  color: #333;
  margin-right: 18px;
  width: 100px;
  display: inline-block;
}
.yonghu-list li {
  display: flex;
  justify-content: flex-start;
  height: 75px;
  line-height: 36px;
  padding: 0 10px;
  text-align: left;
}
.yonghu-list li:nth-child(2n) {
  background: #f7f7f7;
}
.yonghu-list li span img {
  cursor: pointer;
  margin-top: 8px;
}
.yonghu-list li span {
  margin-right: 18px;
  width: 100px;
  display: inline-block;
}
.yonghu-list li a {
  width: auto;
  color: #3377aa;
  margin-right: 18px;
}
.huishou-edu {
  width: 390px;
  height: 250px;
  z-index: 111111111111;
}
.huishou-edu img {
  cursor: pointer;
}
.edu-num {
  font-size: 20px;
  font-weight: 600;
}
.yhguanli {
  height: 380px;
  width: 450px;
  z-index: 111111111111;
}
input[class="tianxiesq"]::-webkit-input-placeholder {
  color: #999999;
  font-size: 14px;
}
input[class="tianxiesq"]:-moz-placeholder {
  color: #999999;
  font-size: 14px;
}
input[class="tianxiesq"]::-moz-placeholder {
  color: #999999;
  font-size: 14px;
}
input[class="tianxiesq"]:-ms-input-placeholder {
  color: #999999;
  font-size: 14px;
}
.guanlianqiye .fp-nm {
  font-size: 16px;
  margin: 20px 0 10px 25px;
}
.kefenpei {
  font-size: 14px;
  color: #3377aa;
  margin-left: 25px;
  margin-top: 20px;
}
.jilu li span.time {
  width: 120px;
}
.jilu li span {
  font-size: 12px;
}
.jilu li span:nth-child(5) {
  width: 180px;
}
.jilu li span:nth-child(6) {
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*������ҵ*/
.guanlianqiye {
  width: 860px;
  height: 320px;
  z-index: 111111111111;
}
.kefenpeib {
  font-size: 12px;
  color: #3377aa;
  margin-left: 15px;
}
.list-cont-glqy p span {
  display: inline-block;
  width: 110px;
}
</style>